// extracted by mini-css-extract-plugin
module.exports = {"nav":"navigation-module--nav--26imw","hiddenNav":"navigation-module--hiddenNav--2ZHz-"};